module.exports = __webpack_public_path__ + "img/lixeira.6baec276.svg";